import { NgModule } from '@angular/core';
import { CartV2Component } from './cart-v2.component';

@NgModule({
  declarations: [CartV2Component],
  exports: [CartV2Component],
})
export class CartV2Module {}
